import { render, staticRenderFns } from "./OfflineChoice.vue?vue&type=template&id=01948756"
import script from "./OfflineChoice.vue?vue&type=script&lang=js"
export * from "./OfflineChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports